import  './styles.css';
import { Typography } from '@mui/material';
import { InfoCircleFilled } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import AntDialog from '../../../../dialogs/dialog';

interface ModalPleaScheduleInfoProps {
    show: boolean,
    toggleShow: () => void,
}

export default function ModalPleaScheduleInfo ({ show, toggleShow }: ModalPleaScheduleInfoProps) {


    return (
        <Modal
            width={650}
            height={200}
            open={show}
            onCancel={toggleShow}
            title={            
                <div className="div-header">
                    <InfoCircleFilled className="icon-info" />
                    <Typography className="title">
                    Gestão Eficiente de Projetos
                    </Typography>
                </div>}
            footer={
                <Button type="primary" onClick={toggleShow}>
                    <Typography>Entendi</Typography>
                </Button>}>

            <div className="div-content">
                <Typography className='text-content'>
                Para facilitar o acompanhamento do projeto, você pode adicionar
                todas as atividades previstas diretamente na tela. Isso permitirá
                que você crie um cronograma detalhado das atividades a serem
                realizadas durante o pleito. Ao visualizar todas as tarefas em um
                único lugar, você poderá gerenciar melhor os prazos, alocar
                recursos de forma eficiente e garantir que todas as etapas do
                projeto sejam concluídas conforme planejado.
                </Typography>
            </div>


        </Modal>
    );
}